export const PoemPushAndPull = () => {
    return (
        <div id="037" className="">
            <p>the smoggy smell of the inner city,</p>
            <p>shadows split out of the soles</p>
            <p>from pairs of feet planted outside the rail station.</p>
            <p>i'm somewhere between the world on the ground and</p>
            <p>the one in my head,</p>
            <p>is there ever a time when we're not confused?</p>
            <p>there's a bullet train speeding through my viscera,</p>
            <p>zero sum game, what's your body to you?</p>
            <p>do you ever slip through the shadows?</p>
            <p>ever move out of sight?</p>
            <p>ever stop the answer</p>
            <p>in your throat?</p>
            <p>not a conflict of interest, just a regular conflict,</p>
            <p>nobody moves and yet for every car passing by</p>
            <p>the shadows streak on the ground -</p>
            <p>double life, </p>
            <p>what's the distance between</p>
            <p>
                what you look like to others and the self you've been secretly
            </p>
            <p>harboring?</p>
            <p>
                where do they meet in the middle? is that a place we can reach?
            </p>
            <p>the message just does not come.</p>
            <p>shadows from the clothes hanged on the balcony</p>
            <p>stretch and cover the walls,</p>
            <p>i never want to impose</p>
            <p>
                and yet is there ever a silence that doesn't feel like a
                stalemate?
            </p>
            <p>no wonder we're never closer than an arm's length,</p>
            <p>"i don't want to obscure more than i need to",</p>
            <p>we both say in unison,</p>
            <p>it's much easier to see in the dark from the dark,</p>
            <p>the problem is just figuring out what exactly it is that you </p>
            <p>need from the other person.</p>
        </div>
    );
};
